import axios from 'axios';
import {serviceUrl} from '../../../config';
import { getSession } from '../../../App';

export const save_userData = async(sObj) => {
  const localsid = getSession();
  try {
     return await axios.put(serviceUrl +'SCM/savePersonalization/' + (localsid), sObj);
  } catch (error) {
     return Promise.reject(error.response)
  }
}
export const get_leaders = async (rid,cid) => {  
  const localsid = getSession();
      try {
        return await axios.post(serviceUrl +'SCM/getleaders/' + (localsid),{"resource_id":rid,"course_id":cid});
      } catch (error) {
        return Promise.reject(error.response)
     }
}
export const get_settings = async () => {      
  const localsid = getSession();
      try {
        return await axios.post(serviceUrl +'SCM/settings/' + (localsid),{});
      } catch (error) {
        return Promise.reject(error.response)
     }
}

export const save_settings = async(sObj) => {
  const localsid = getSession();
  try {
     return await axios.put(serviceUrl +'SCM/settings/' + (localsid), sObj);
  } catch (error) {
     return Promise.reject(error.response)
  }
}

export const init_simulation = async (sessionid) => {      
  const localsid = getSession();
      try {
        return await axios.post(serviceUrl +'SCM/' + (localsid != undefined ? sessionid : ''),{});
      } catch (error) {
        return Promise.reject(error.response)
     }
}
export const make_request_bids = async(sessionid, pSimObj) => {
  const localsid = getSession();
  try {
     return await axios.put(serviceUrl +'SCM/' + (localsid != undefined ? sessionid : ''), pSimObj);
  } catch (error) {
     return Promise.reject(error.response)
  }
}

export const play_simulation = async(sessionid, pSimObj) => {
  const localsid = getSession();
  try {
     return await axios.put(serviceUrl +'SCM/' + (localsid != undefined ? sessionid : ''), pSimObj);
  } catch (error) {
     return Promise.reject(error.response)
  }
}
export const make_place_order = async(sessionid, pSimObj) => {
  const localsid = getSession();
  try {
     return await axios.put(serviceUrl +'SCM/' + (localsid != undefined ? sessionid : ''), pSimObj);
  } catch (error) {
     return Promise.reject(error.response)
  }
}
export const make_cancel_order = async(sessionid, pSimObj) => {
  const localsid = getSession();
  try {
     return await axios.put(serviceUrl +'SCM/' + (localsid != undefined ? sessionid : ''), pSimObj);
  } catch (error) {
     return Promise.reject(error.response)
  }
}
// export const order_history = async(sessionid, id) => {
//   const localsid = getSession();
//   try {
//      return await axios.post(serviceUrl +'SCM/orderhistory/' + (localsid != undefined ? sessionid : ''), {"id": id});  
//   } catch (error) {
//      return Promise.reject(error.response)
//   }
// }
export const startover_simulation = async(sessionid) => {
  const localsid = getSession();
  try {
    return await axios.post(serviceUrl +'SCM/addattempt/' + (localsid != undefined ? sessionid : ''));
  } catch (error) {
     return Promise.reject(error.response)
  }
}

export const get_summary_report = async(sessionid,executioninstanceid) => {
  const localsid = getSession();
  try {
    return await axios.post(serviceUrl +'SCM/summaryreport/' + (localsid != undefined ? sessionid : ''),{
      "executioninstanceid":executioninstanceid
    });
  } catch (error) {
     return Promise.reject(error.response)
  }
}

export const get_list_of_users = async(sessionid,resource_id,course_id) => {
  const localsid = getSession();
  try {
    return await axios.post(serviceUrl +'SCM/getListOfUsers/' + (localsid != undefined ? sessionid : ''),{
      "resource_id": resource_id,
      "course_id": course_id
    });
  } catch (error) {
     return Promise.reject(error.response)
  }
}

export const get_simulation_detail_summary = async(sessionid,selected_sessionid) => {
  const localsid = getSession();
  try {
    return await axios.post(serviceUrl +'SCM/getSimulationDetailSummary/' + (localsid != undefined ? sessionid : ''),{
      "selected_sessionid": selected_sessionid
    });
  } catch (error) {
     return Promise.reject(error.response)
  }
}
export const get_best_attempt = async(sessionid,resource_id,course_id) => {
  const localsid = getSession();
  try {
    return await axios.post(serviceUrl +'SCM/getBestAttempt/' + (localsid != undefined ? sessionid : ''),{
      "resource_id": resource_id,
      "course_id": course_id
    });
  } catch (error) {
     return Promise.reject(error.response)
  }
}
export const get_decision_history = async(sessionid,executioninstanceid) => {
  const localsid = getSession();
  try {
    return await axios.post(serviceUrl +'SCM/getDecisionHistory/' + (localsid != undefined ? sessionid : ''),{
      "executioninstanceid":executioninstanceid
    });
  } catch (error) {
     return Promise.reject(error.response)
  }
}
//Prework API Intigration
export const get_prework = async () => {  
  const localsid = getSession();
      try {
        return await axios.post(serviceUrl.split('simulation/')[0] +'prework/SCM/' + (localsid),{});
      } catch (error) {
        return Promise.reject(error.response)
     }
}
export const UpdateDataPrework = async(sObj) => {
  const localsid = getSession();
  try {
     return await axios.put(serviceUrl.split('simulation/')[0]  +'prework/SCM/' + (localsid), sObj);
  } catch (error) {
     return Promise.reject(error.response)
  }
}
export const retry_prework = async(sessionid) => {
  const localsid = getSession();
  try {
    return await axios.post(serviceUrl +'SCM_PREWORK/addattempt/' + (localsid != undefined ? sessionid : ''));
  } catch (error) {
      return Promise.reject(error.response)
  }
}

// Reflection API

export const get_reflection_report = async(sessionid,selected_sessionid) => {
  const localsid = getSession();
  try {
    return await axios.post(serviceUrl.split('simulation/')[0] +'reflection/SCM_REFLECTION/report/' + (sessionid != undefined ? sessionid : localsid));
  } catch (error) {
     return Promise.reject(error.response)
  }
}
export const get_list_of_users_reflection = async(sessionid,resource_id,course_id) => {
  // const localsid = getSession();
  try {
    return await axios.post(serviceUrl +'SCM_REFLECTION/getListOfUsers/' + sessionid,{
      "resource_id": resource_id,
      "course_id": course_id
    });
  } catch (error) {
     return Promise.reject(error.response)
  }
}
export const get_reflection = async (sid) => {  
  let localsid = getSession();
  if(sid){
    localsid = sid;
  }
  try {
    return await axios.post(serviceUrl.split('simulation/')[0] +'reflection/SCM/' + (localsid),{});
  } catch (error) {
    return Promise.reject(error.response)
  }
}

export const update_reflection = async(sObj) => {
  const localsid = getSession();
  try {
     return await axios.put(serviceUrl.split('simulation/')[0]  +'reflection/SCM/' + (localsid), sObj);
  } catch (error) {
     return Promise.reject(error.response)
  }
}

export const get_prework_attempt = async(sessionid,attempt) => {
  const localsid = getSession();
  try {
    return await axios.post(serviceUrl.split('simulation/')[0] +'prework/SCM/attempt/'  + (localsid != undefined ? sessionid : '')+"/"+attempt);
  } catch (error) {
     return Promise.reject(error.response)
  }
}

export const get_best_attempt_prework = async(sessionid,resource_id,course_id) => {
  const localsid = getSession();
  try {
    return await axios.post(serviceUrl.split('simulation/')[0] +'prework/SCM_PREWORK/bestattempts/' + (localsid != undefined ? sessionid : ''),{
      "resource_id": resource_id,
      "course_id": course_id
    });
  } catch (error) {
     return Promise.reject(error.response)
  }
}

export const get_simulation_detail_summary_prework = async(sessionid,selected_sessionid) => {
  const localsid = getSession();
  try {
    return await axios.post(serviceUrl +'SCM_PREWORK/getSimulationDetailSummary/' + (localsid != undefined ? sessionid : ''),{
      "selected_sessionid": selected_sessionid
    });
  } catch (error) {
     return Promise.reject(error.response)
  }
}

export const get_list_of_users_prework = async(sessionid,resource_id,course_id) => {
  // const localsid = getSession();
  try {
    return await axios.post(serviceUrl +'SCM_PREWORK/getListOfUsers/' + sessionid,{
      "resource_id": resource_id,
      "course_id": course_id
    });
  } catch (error) {
     return Promise.reject(error.response)
  }
}
// export const pause_simulation = async() => {
    
// }
// export const exit_simulation = () => {

// }

// export const abort_simulation = () => {

// }

// export const get_simulation_details = () => {

// }
// export const get_decision_history = () => {

// }

// export const get_all_simulation = () => {

// }

// export const get_simulation_version = () => {

// }

// export const get_version_details = () => {

// }